// @flow

import { hpfetch } from '../util';
import type {
  djangoModelApiResponse,
  wrappedApiResponseType,
} from '../apiTypes';
import type { supplyProposalType } from '../../types';

export const getSingle = (
  id: number,
): Promise<wrappedApiResponseType<supplyProposalType>> =>
  hpfetch(`supply-proposals/${id}/`);

export const getMany = (
  limit: number = 100,
  offset: number = 0,
): djangoModelApiResponse<supplyProposalType> =>
  hpfetch(
    `supply-proposals/?limit=${limit}&offset=${offset}&include_archived=true`,
  );

export const create = (wantedId: number, offeringId: number, message: string) =>
  hpfetch('supply-proposals/', {
    method: 'POST',
    body: JSON.stringify({
      wanted: wantedId,
      offering: offeringId,
      message,
    }),
  });

export const archive = (id: number, archived: boolean) =>
  hpfetch(`supply-proposals/${id}/`, {
    method: 'PATCH',
    body: JSON.stringify({
      archived,
    }),
  });
